import { clone } from './clone';

export function cloneDeep<T>(value: T): T {
  if (typeof value !== 'object' || value == null) {
    return clone(value);
  }

  if (Array.isArray(value)) {
    return value.map(cloneDeep) as T;
  }

  return Object.fromEntries(
    Object.entries(value).map(([key, value]) => [key, cloneDeep(value)]),
  ) as T;
}
